
interface Rate {
  res_FP1?: number;
  res_FP2?: number;
  res_FP3?: number;
  surplusLinesTax?: number;
  stampingFee?: number;
  res_9PayMent?: number;
  res_Policy?: number;
}
import { formatCurrencyCompactLong } from "@/plugins/filters";
import { PropType } from "vue";
import Vue from "vue";

export default Vue.extend({
  name: "Taxes",
  props: {
    rate: {
      type: Object as PropType<Rate>,
      required: true
    }
  },
  methods: {
    formatCurrency(value: number): string {
      if ((value && !isNaN(value)) || value === 0) {
        return formatCurrencyCompactLong(value);
      } else {
        return "N/A";
      }
    }
  },
  computed: {
    fairPlan(): number {
      if (this.rate?.res_FP1) {
        return this.rate.res_FP1;
      }
      if (this.rate?.res_FP2) {
        if (this.rate?.res_FP3) {
          return Number(this.rate.res_FP2) + Number(this.rate.res_FP3);
        }
        return this.rate.res_FP2;
      }
      return 0;
    }
  }
});
